export const daysAgo = (days) => {
  const date = new Date();
  date.setDate(date.getDate() - days);

  return date.toISOString().split('T')[0];
};

export const firstOf = (offset = 0) => {
  const now = new Date();
  const date = new Date(Date.UTC(now.getFullYear(), now.getMonth() - offset, 1));

  return date.toISOString().split('T')[0];
};

export const toUTCDate = (dateInput) => {
  const d = new Date(dateInput);

  return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()));
};

export const toYMD = dateInput => dateInput.toISOString().split('T')[0];

export const toLocaleDateStringIgnoringTimezone = (value) => {
  const date = new Date(value);

  return new Intl.DateTimeFormat(navigator.language, {
    timeZone: 'UTC',
  }).format(date);
};

export const toMonthLabel = value => new Intl.DateTimeFormat(navigator.language, {
  month: 'short',
  year: 'numeric',
  timeZone: 'UTC',
}).format(new Date(value));

export const formatDuration = (milliseconds) => {
  const days = Math.floor(milliseconds / (1000 * 60 * 60 * 24));
  const hours = Math.floor((milliseconds % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((milliseconds % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((milliseconds % (1000 * 60)) / 1000);

  return `${days}d ${hours}h ${minutes}m ${seconds}s`;
};
